<template>
  <v-row class="py-0 mr-1">
    <v-col cols="3" class="py-5" :class="{ 'field-disabled': isDisabled }">
      <v-subheader :class="{ 'text-disabled': isDisabled }">{{appConfiguration.title }}
        <v-tooltip top color="rgb(84,79,105)" v-if="appConfiguration.tooltip">
          <template v-slot:activator="{ on, attrs }">
            <v-icon
                small
                color="gray"
                v-bind="attrs"
                v-on="on"
                class="pl-2"
            >
              fas fa-info-circle
            </v-icon>
          </template>
          <span>{{appConfiguration.tooltip}}</span>
        </v-tooltip>
      </v-subheader>

    </v-col>
    <v-col cols="8" class="py-5">
      <v-text-field :disabled="isDisabled" v-if="appConfiguration.fieldType == 'TEXT'" v-model="appConfiguration.value" :outlined="editing" dense @change="onValueChanged" />
      <v-text-field :disabled="isDisabled"  v-else-if="appConfiguration.fieldType == 'NUMBER'" v-model.number="appConfiguration.value" :outlined="editing" ense @change="onValueChanged" />
      <v-checkbox :disabled="isDisabled" v-else-if="appConfiguration.fieldType == 'CHECKBOX'" v-model="checkValue" @change="onValueChanged"/>
      <v-select :disabled="isDisabled" v-else-if="appConfiguration.fieldType == 'SELECT'" :items="appConfiguration.options" v-model="appConfiguration.value" :outlined="editing"  dense @change="onValueChanged" />
      <v-select :disabled="isDisabled" v-else-if="appConfiguration.fieldType == 'COMBO'"  multiple :items="appConfiguration.options" v-model="appConfiguration.value" :outlined="editing"  dense @change="onValueChanged" />
      <template v-else-if="appConfiguration.fieldType == 'COMBO_MAIL_TEMPLATE'">
        <v-text-field v-if="!editing" :value="selectedMailTemplateName" :disabled="isDisabled" readonly dense />
        <v-select v-else :disabled="isDisabled" :items="mailTemplateOptions" v-model="appConfiguration.value" :outlined="editing" dense :loading="loadingMailTemplates" item-text="name" item-value="id" @focus="loadAllMailTemplates" @change="onValueChanged" />
      </template>
      <date-picker :disabled="isDisabled" v-else-if="appConfiguration.fieldType == 'DATE'" :date-prop="appConfiguration.value" v-on:updateDate="updateDate"/>
    </v-col>
    <v-col cols="1">
      <v-icon
          v-show="!editing"
          small
          color="gray"
          class="pl-2"
          @click="startEdit()"
      >
        fas fa-pencil-alt
      </v-icon>
    </v-col>
  </v-row>
</template>

<script>

import DatePicker from '../../components/date-picker/index.vue';
import MailTemplateService from '@/services/odoo/MailTemplateService';
export default {
  name: "configField",
  components: {
    DatePicker
  },
  props: {
    appConfiguration :{
      type: Object
    },
    editing: {
      type: Boolean,
      default: false
    },
    enabled: {
      type: Boolean,
      default: true
    }
  },
  data: () => ({
    mailTemplateOptions: [],
    loadingMailTemplates: false,
  }),
  computed: {
    isDisabled() {
      return !this.editing || !this.enabled;
    },
    checkValue: {
      get () {
        return JSON.parse(this.appConfiguration.value);
      },
      set (val) {
        this.appConfiguration.value = val;
      },
    },
    selectedMailTemplateName() {
      if (!this.appConfiguration.value) return '';
      const template = this.mailTemplateOptions.find(t => String(t.id) === String(this.appConfiguration.value));
      return template ? template.name : '';
    }
  },
  methods: {
    startEdit(){
      this.$emit('startEdit');
    },
    updateDate(date){
      if(this.appConfiguration.fieldType == 'DATE'){
        this.appConfiguration.value = date;
        this.onValueChanged();
      }
    },
    onValueChanged(){
      this.$emit('valueChanged', {
        idAppConfigField: this.appConfiguration.idAppConfigField,
        value: this.appConfiguration.value
      });
    },
    async resolveMailTemplateValue() {
      this.loadingMailTemplates = true
      try {
        const response = await this._mailTemplateService.FindById(this.appConfiguration.value)
        if (response && response.data) {
          this.mailTemplateOptions = [{ ...response.data, id: String(response.data.id) }]
        }
      } catch (e) {
        this.mailTemplateOptions = []
      } finally {
        this.loadingMailTemplates = false
      }
    },
    async loadAllMailTemplates() {
      if (this.mailTemplateOptions.length > 1) {
        return
      }
      this.loadingMailTemplates = true
      try {
        const response = await this._mailTemplateService.FindAllBackend()
        this.mailTemplateOptions = (response.data || []).map(t => ({ ...t, id: String(t.id) }))
      } catch (e) {
        this.mailTemplateOptions = []
      } finally {
        this.loadingMailTemplates = false
      }
    },
  },
  created() {

    if(this.appConfiguration.fieldType == 'COMBO' || this.appConfiguration.fieldType == 'SELECT' ){
      this.appConfiguration.options = this.appConfiguration.optionValues ? this.appConfiguration.optionValues.split(",") : [];
    }
    if(this.appConfiguration.fieldType == 'COMBO'){
      this.appConfiguration.value = this.appConfiguration.value ? this.appConfiguration.value.split(",") : [];
    }
    if(this.appConfiguration.fieldType == 'COMBO_MAIL_TEMPLATE'){
      this._mailTemplateService = new MailTemplateService()
      if(this.appConfiguration.value){
        this.resolveMailTemplateValue()
      }
    }
  },

}
</script>

<style scoped>
.field-disabled {
  opacity: 0.5;
}
.text-disabled {
  color: var(--v-textDisabled) !important;
}
</style>
